import { useContext } from 'react';

import { ManuallyEditQSetModalContext } from './manually-edit-q-set-modal-provider';

function useManuallyEditQSetModal() {
  const context = useContext(ManuallyEditQSetModalContext);

  if (!context) {
    throw new Error('useManuallyEditQSetModal must be used within a ManuallyEditQSetModalProvider');
  }

  return context;
}

export { useManuallyEditQSetModal };
